<template>
  <div class="main-container">
    <div class="detail hidden-sm-and-down">
        <div class="banner">
          <img :src="imgsrc + backimg" alt="" />
        </div>
        <div class="prodetail">
          <div class="probox">
            <el-row :gutter="20">
              <el-col :md="6" :sm="12" :xs="24" v-for="(item, index) in productdetail" :key="index">
                <div class="grid-content bg-purple">
                  <router-link :to="{ name:'Product', query: {id: item.id} }">
                  <img class="qwimg" v-if="item.is_authority == 1" src="../../static/qw.png" alt="">
                  <img class="procover" :src="imgsrc + item.cover" alt="" />
                  <p>{{ item.name }}</p>
                  <h5 v-if="isPriceOnRequest(item.price)" class="price-fallback">价格详询在售渠道</h5>
                  <h5 v-else>￥{{ (+item.price).toFixed(2)}}</h5>
                  </router-link>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
    </div>

    <!-- 手机端显示 -->
    <div class="hidden-md-and-up mobproduct">
      <div class="mobBanner" v-if="hasQuery"> 
        <img :src="imgsrc + backmobimg" alt="" />
      </div>
      <div class="tab"> 
        <ul>
          <li @click="Alllist" :class="{active:cur==0}">查看全部</li>
          <li @click="cur=1" :class="{active:cur==1}">按销量</li>
          <li @click="doPrice" :class="{active:cur==2}">按价格</li>
          <li  @click="Mode" >浏览模式
            <img :src="flag== true ? '../../static/mobile/list1.png': '../../static/mobile/list2.png'" />
          </li>
        </ul>
      </div>
      <div class="productlist">
        <ul v-show="productshow" class="listone">
          <li v-for="(item, index) in productdetail" :key="index">
            <div @click="skleHandl(item.id)">
              <!-- <img :style=" id == 2 ? 'width:1.9rem;padding-top:1rem'  : 'width:2.7rem'" :src="imgsrc + item.cover" alt=""> -->
              <img :src="imgsrc + item.cover" alt="">
            </div>
            <p>{{ item.name }}</p>
            <h5 v-if="isPriceOnRequest(item.price)" class="price-fallback">价格详询在售渠道</h5>
            <h5 v-else>￥{{ (+ item.price).toFixed(2) }}</h5>
            <router-link :to="{ name:'Product', query: {id: item.id} }">
              查看产品
            </router-link>
          </li>
        </ul>
        <div v-show="productTowshow" class="listtwo">
          <div class="producbox" v-for="(item, index) in productdetail" :key="index">
            <div class="producboxlef">
               <!-- <img :style=" id == 2 ? 'width:1.9rem' : 'width:2.7rem'"  :src="imgsrc + item.cover" alt=""> -->
               <img :src="imgsrc + item.cover" alt="">
            </div>
            <div class="producboxrig">
                 <p>{{ item.name }}</p>
                  <h5 v-if="isPriceOnRequest(item.price)" class="price-fallback">价格详询在售渠道</h5>
                  <h5 v-else>￥{{ (+ item.price).toFixed(2) }}</h5>
                  <router-link :to="{ name:'Product', query: {id: item.id} }">
                    查看产品
                  </router-link>
            </div>
          </div>
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import { product_list_data_url } from "../request/api.js";
export default {
  name: "Product_List",
  components: {},
  directives: {},
  data() {
    return {
      productdetail: [],
      backimg: this.imgLoading,
      backmobimg:this.imgLoading,
      productTowshow:false,
      productshow:true,
      flag: true,
      id:"",
      cur:'0',
      hasQuery:true
    };
  },
watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.id) {
        location.reload();
      }
      if (to.name) {
        this.$router.go(0);
      }
    },
  },
  mounted() {
    
   this.datelist()
  },
 
  methods: {
    Mode(){
      this.cur = 3
    this.flag = !this.flag
    if(this.flag){
      this.productTowshow=false
      this.productshow = true
    }else{
      this.productshow = false
      this.productTowshow=true
    }
    },

      Alllist(){
        this.datelist()
        this.cur = 0
      },
skleHandl(id){
this.$router.push({path:'/Product',query:{id:id}})
},
  datelist(){
    if(this.$route.query.id === undefined ){
        this.hasQuery=false;
        let tempCookie=this.$cookies.get('Product_List')
        this.productdetail =typeof(tempCookie)=='object'
                            ?tempCookie
                            :JSON.parse(tempCookie)
        }else{
            this.id = this.$route.query.id;
          product_list_data_url({ id: this.id }).then((res) => {
          this.productdetail = res.data.data.list;
          this.backimg = res.data.data.list_product_bg;
          this.backmobimg = res.data.data.list_product_bg_h5
        });
        }
  },
     doPrice() {
      this.productdetail.sort((a, b) => {
        const ax = this.isPriceOnRequest(a.price);
        const bx = this.isPriceOnRequest(b.price);
        if (ax && !bx) return 1;
        if (!ax && bx) return -1;
        if (ax && bx) return 0;
        return Number(a.price) - Number(b.price);
      });
      this.cur = 2;
    },
    isPriceOnRequest(p) {
      const n = Number(p);
      return !Number.isFinite(n) || n <= 0;
    },
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      console.log(to.query.id);
      if (to.query.id) {
        location.reload();
      }
    },
  },
  
};
</script>

<style lang="less" scoped>
.price-fallback {
  font-size: 0.75em !important;
  font-weight: normal !important;
}
.detail {
  width: 100%;
  .banner {
    width: 100%;
    font-size: 0;
    img {
      width: 100%;
    }
  }
  .prodetail {
    width: 100%;
  //  min-height:calc(100vh - 300px);
    .probox {
      padding: 4% 10.7% 1% 10.7%;
      .bg-purple{
          background:url('../../static/detailbj.png')no-repeat;
          background-size:100% 100%;
          position: relative;
          max-width: 350px;
          margin-bottom: 52px;
          z-index: 1;
      }
      .qwimg{
        width:35%;
        max-width:124px;
        position: absolute;
        left: 15%;
        top: 10%;
        z-index: -1;
      }
      .procover {
        width: 60%;
        margin-top: 19%;
      }
      span {
        display: inline-block;
        width: 100%;
        margin: 20% 0 4% 0;
        font-size: 16px;
        color: #00383F;
        font-weight: bold;
      }
      p {
        font-size: 18px;
        color: #00383f;
        font-weight: 200;
        width: 80%;
        min-height: 42px;
        margin: 0 auto;
        padding-top: 10%;
      }
      h5{
          font-size: 18px;
          padding-bottom: 12%;
          padding-top: 7%;
          color: #00383f;
      }
    }
  }
}

.mobproduct{
  .mobBanner{
    img{
      width: 100%;
    }
  }
.productlist{
  background: url(../../static/mobile/productbg.png) no-repeat;
  background-size: 100% 100%;
  min-height: 10rem;
  .listone{
    padding-top: 0.5rem;
    margin: 0 0.6rem;
    overflow: hidden;
    li{
      display: inline-block;
      width: 2.9rem;
      color: #00383F;
      float: left;
      div{
           border: 1px solid #00383F;
            border-radius: 5px;
            background: #fff;
            height: 4rem;
        img{
          width: 2.7rem;
          padding: 0.5rem 0;
        }
      }
      p{
        width: 2.1rem;
        margin: 0 auto;
        font-size: 0.33rem;
        margin-top: 0.34rem;
        height: 0.8rem;

      }
      h5{
        font-size: 0.25rem;
        margin-top: 0.45rem;
      }
      a{
        display: inline-block;
        width: 2.1rem;
        height: 0.65rem;
        background: #00383F;
        font-size: 0.33rem;
        font-weight: 900;
        color: #fff;
        line-height: 0.65rem;
        margin: 0.3rem 0 0.7rem 0;
      }
    }

       li:nth-child(2n){
      margin-left: 0.5rem;
    }
  }
 .listtwo{
   width: 100%;
   padding-top: 0.5rem;
   .producbox{
     margin-left: 0.6rem;
     padding-bottom: 0.7rem;
     display: flex;
     .producboxlef{
       width: 2.9rem;
       border: 1px solid #00383F;
        border-radius: 5px;
        background: #fff;
       img{
         width: 2.7rem;
         padding: 0.5rem 0;
       }
     }
     .producboxrig{
       margin-left: 0.5rem;
       text-align: left;
         p{
        width: 2.1rem;
        margin: 0 auto;
        font-size: 0.33rem;
        margin-top: 0.6rem;
        min-height: 0.75rem;

      }
      h5{
        font-size: 0.25rem;
        margin-top: 0.45rem;
      }
      a{
        display: inline-block;
        width: 2.1rem;
        height: 0.65rem;
        background: #00383F;
        font-size: 0.33rem;
        font-weight: 900;
        color: #fff;
        line-height: 0.65rem;
        margin-top: 0.99rem;
        text-align: center;
      }
     }
   }
 }

}
  .tab{
    width: 100%;
    height: 1rem;
    background: #fff;
    ul{
      height: 1rem;
      display: -webkit-flex;
      display: inline-flex;
      align-items: center;
      li{
        width: 1.31rem;
        font-size: 0.25rem;
        font-weight: bold;
        color: #00383F;
        border-right: 1px solid  rgba(0, 56, 63, 0.5);
        height: 0.52rem;
        line-height: 0.52rem;
     
      }
         .active{
          color: #AB0000!important;
        }
      :last-child{
        border-right: unset;
        width: 1.8rem;
        img{
          width:0.33rem;
          vertical-align: text-bottom;
          float: right;
          padding-top: 0.12rem;
        }
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/view/Product_List.vue